export default {
    getPatentStatuses(){
        return axios.get('https://api.leadingedgeonly.com/api/v1/patent-statuses')
        .then((response) =>  {
            return response.data;
        })
        .catch(function (error) {
            console.log(error);
        });
    }
}